/**
 * @generated SignedSource<<88f73c550d9e00c983630db2063ff97c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResourceOwnerConfigurationInput = {
  default?: ReadonlyArray<string> | null | undefined;
  name: string;
  orgDomain?: string | null | undefined;
  orgDomainTag?: string | null | undefined;
  scope: string;
  tags: ReadonlyArray<string>;
};
export type AccountOwnersConfigurationInput = {
  default?: ReadonlyArray<AccountOwnersInput> | null | undefined;
  name?: string | null | undefined;
  orgDomain?: string | null | undefined;
  orgDomainTag?: string | null | undefined;
  scope: string;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type AccountOwnersInput = {
  account: string;
  owners: ReadonlyArray<string>;
};
export type AddOwnerProfileMutation$variables = {
  accountOwnerProfileInput: AccountOwnersConfigurationInput;
  connections: ReadonlyArray<string>;
  resourceOwnerProfileInput: ResourceOwnerConfigurationInput;
};
export type AddOwnerProfileMutation$data = {
  readonly addAccountOwnersProfile: {
    readonly configuration: {
      readonly profile: string;
      readonly record: {
        readonly default?: ReadonlyArray<{
          readonly owners: ReadonlyArray<string>;
        }>;
        readonly tags?: ReadonlyArray<string>;
      };
    };
  } | null | undefined;
  readonly addResourceOwnerProfile: {
    readonly configuration: {
      readonly profile: string;
      readonly record: {
        readonly default?: ReadonlyArray<string> | null | undefined;
        readonly tags?: ReadonlyArray<string>;
      };
    };
  } | null | undefined;
};
export type AddOwnerProfileMutation = {
  response: AddOwnerProfileMutation$data;
  variables: AddOwnerProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountOwnerProfileInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceOwnerProfileInput"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "accountOwnerProfileInput"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profile",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountOwners",
      "kind": "LinkedField",
      "name": "default",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "owners",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "type": "AccountOwnersConfiguration",
  "abstractKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "resourceOwnerProfileInput"
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default",
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "type": "ResourceOwnerConfiguration",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "filters": null,
  "handle": "appendNode",
  "key": "",
  "kind": "LinkedHandle",
  "name": "configuration",
  "handleArgs": [
    {
      "kind": "Variable",
      "name": "connections",
      "variableName": "connections"
    },
    {
      "kind": "Literal",
      "name": "edgeTypeName",
      "value": "ConfigurationEdge"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddOwnerProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "addAccountOwnersProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "addResourceOwnerProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AddOwnerProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "addAccountOwnersProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          (v11/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "addResourceOwnerProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6cd028ebb10c0cfc9e6d5d7bfc327e71",
    "id": null,
    "metadata": {},
    "name": "AddOwnerProfileMutation",
    "operationKind": "mutation",
    "text": "mutation AddOwnerProfileMutation(\n  $resourceOwnerProfileInput: ResourceOwnerConfigurationInput!\n  $accountOwnerProfileInput: AccountOwnersConfigurationInput!\n) {\n  addAccountOwnersProfile(input: $accountOwnerProfileInput) {\n    configuration {\n      profile\n      record {\n        __typename\n        ... on AccountOwnersConfiguration {\n          default {\n            owners\n          }\n          tags\n        }\n      }\n      id\n    }\n  }\n  addResourceOwnerProfile(input: $resourceOwnerProfileInput) {\n    configuration {\n      profile\n      record {\n        __typename\n        ... on ResourceOwnerConfiguration {\n          default\n          tags\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "483866eb131abd64882df9c4e8972c71";

export default node;
